import { EnrollmentCourse } from '@/models/mamata/enrollment-course.model';
import {
  WESTEROS_AUTHORIZATION_ENUM,
  WESTEROS_MICROSERVICES_ENUM,
  westerosQuery,
} from '@/helpers/westeros';
import { getCoursesUserEnrolledIn } from '@/store/queries/mamata.queries';

export class EnrolledCoursesService {
  static async getUserEnrolledCourses(): Promise<EnrollmentCourse[]> {
    const enrolledCourses = await westerosQuery(
      WESTEROS_MICROSERVICES_ENUM.MAMATA,
      getCoursesUserEnrolledIn,
      {},
      WESTEROS_AUTHORIZATION_ENUM.PROFILE,
    );

    const {
      data: { userCourses },
    } = enrolledCourses;

    return userCourses;
  }
}
